import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onBeforeMount } from "vue";
import { useWindowResize } from "@/utils/useWindowSize";
import FiltersDialog from "@/components/base/filters/FiltersDialog.vue";
import FiltersDesign from "@/components/base/filters/FiltersDesign.vue";
import { PrivateRatesFilters } from "@/services/TablePage/private-rates";
import { usePrivateRatesStore } from "@/store_v3/PrivateRatesStore";
import store from "@/store";
import { storeToRefs } from "pinia";
import { getOneEmployeesOffer } from "@/api/offers";
import { showServerError } from "@/utils";
import { IOfferV2 } from "@/api/types/offers";
import { IFilter } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateRatesFilters',
  setup(__props) {

const { width } = useWindowResize();
const isDesktop = computed(() => width.value >= 768);
const isFullWidth = computed(() => width.value <= 576);
const getWidth = computed(() => isDesktop.value ? 680 : isFullWidth.value ? 576 : 340);

const isShowFilters = ref(false);
const filters = ref<PrivateRatesFilters | null>(null);
const { isNeedUpdateRates } = storeToRefs(usePrivateRatesStore());

const findFilter = (id: string): IFilter | undefined => (
    filters.value?.filters.find((filter) => filter.id === id)
);

let offerGoalsRequestId = 0;

onBeforeMount(() => {
    store.commit('SET_FILTERS_PARAMS_OBJECT', {});
    store.commit('SET_DEFAULT_FILTERS_PARAMS_OBJECT', {});
    filters.value = new PrivateRatesFilters();
    filters.value.applyDefaultFilters();
});

watch(
    () => findFilter('offer_id')?.select,
    async (value) => {
        const goalFilter = findFilter('goal_id');
        if (!filters.value || !goalFilter) {
            return;
        }

        const hasOffer = !!value?.length;
        goalFilter.disabled = !hasOffer;

        if (!hasOffer) {
            goalFilter.select = [];
            goalFilter.items = [];
            return;
        }

        const legacyId = value[0].legacy_id;
        const requestId = ++offerGoalsRequestId;
        const offer = await fetchOffer(legacyId);
        if (requestId !== offerGoalsRequestId) {
            return;
        }
        goalFilter.items = offer?.goals ?? [];
    },
    { deep: true, immediate: true },
);

const fetchOffer = async (id: number): Promise<IOfferV2 | undefined> => {
    try {
        return await getOneEmployeesOffer(id);
    } catch (e) {
        showServerError(e, 'Цели оффера не загружены');
    }
};

const submitFilters = () => {
    isNeedUpdateRates.value = true;
    isShowFilters.value = false;
};

const clearFilters = () => {
    isNeedUpdateRates.value = true;
};

return { __sfc: true,width, isDesktop, isFullWidth, getWidth, isShowFilters, filters, isNeedUpdateRates, findFilter, offerGoalsRequestId, fetchOffer, submitFilters, clearFilters, FiltersDialog, FiltersDesign }
}

})